const config = {
  apiBaseUrl: "https://www.turbobe.com",
  // apiBaseUrl: "http://localhost:8000",
};

export default config;
